<template>
  <div class="color-options">
    <!-- Single Mode -->
    <div class="color-picker-in-single-container" v-if="mode === 'single'">
      <ColorOptionsItem
        v-for="(color, index) in colorOptions"
        :key="index + '-color-single' + componentKey"
        :color="color"
        :colorKey="colorKey"
        :selectedColorId="selectedColorId"
        :showOnlyCircle="true"
        @selectColor="emitSelectColor"
      />
    </div>

    <!-- Multiple Mode -->
    <div
      class="color-picker-multiple-container"
      v-else-if="mode === 'multiple'"
    >
      <div class="picker-tooltip" :class="tooltipNumberKey"></div>
      <div class="color-picker-multiple-header">
        <p>{{ multiplePickerHeader }}</p>
        <CloseButton @close="$emit('close')" />
      </div>
      <div class="options-container">
        <ColorOptionsItem
          v-for="(color, index) in colorOptions"
          :key="index + '-color-multiple' + componentKey"
          :color="color"
          :colorKey="colorKey"
          :selectedColorId="selectedColorId"
          @selectColor="emitSelectColor"
        />
        <!-- None color option -->
        <ColorOptionsItem
          v-if="allowNoneColorOption && !isFirstColorOption"
          :key="
            colorOptions &&
            colorOptions.length + '-color-multiple' + componentKey
          "
          :color="noneColorOption"
          :colorKey="colorKey"
          :selectedColorId="selectedColorId"
          @selectColor="emitSelectColor"
        />
      </div>
    </div>
  </div>
</template>

<script>
import ColorOptionsItem from "@/components/Projects/Project/Colors/ColorOptionsItem.vue";
import CloseButton from "@/components/Utils/CloseButton.vue";

export default {
  name: "ColorOptions",
  components: { ColorOptionsItem, CloseButton },
  props: {
    colorKey: {
      type: String, //color_1, color_2,color_3
    },
    mode: {
      type: String,
    },
    selectedColorId: {
      type: Number,
    },
    isPickerOpen: {
      type: Boolean,
    },
    colorOptions: {
      type: Array,
    },
    allowNoneColorOption: {
      type: Boolean,
      default: false,
    },
    componentKey: {
      type: String,
    },
  },

  data() {
    return {
      noneColorOption: {
        id: null,
        assetId: "",
        name: "None",
        hex: "transparent",
      },
    };
  },

  computed: {
    multiplePickerHeader() {
      switch (this.colorKey) {
        case "color_1" || "Color 1":
          return "select main color";

        case "color_2" || "Color 2":
          return "select second color";

        case "color_3" || "Color 3":
          return "select third color";

        case "fill":
          return "select fill color";

        case "outline":
          return "select outline color";

        case "outline_1":
          return "select outline 1 color";

        case "outline_2":
          return "select outline 2 color";

        default:
          return "select main color";
      }
    },

    isFirstColorOption() {
      return (
        this.colorKey === "fill" ||
        this.colorKey === "color_1" ||
        this.colorKey === "color 1"
      );
    },
    isSecondColorOption() {
      return (
        this.colorKey === "outline_1" ||
        this.colorKey === "color_2" ||
        this.colorKey === "color 2"
      );
    },
    isThirdColorOption() {
      return (
        this.colorKey === "outline_2" ||
        this.colorKey === "color_3" ||
        this.colorKey === "color 3"
      );
    },

    tooltipNumberKey() {
      return {
        first: this.isFirstColorOption,
        second: this.isSecondColorOption,
        third: this.isThirdColorOption,
      };
    },
  },

  methods: {
    emitSelectColor(data) {
      this.$emit("selectColor", data);
    },
  },
};
</script>

<style lang="scss" scoped>
.color-options {
  position: relative;

  .color-picker-in-single-container {
    display: grid;
    grid-template-columns: repeat(8, 1fr);
    row-gap: 1rem;
    @media screen and (max-width: 1024px) {
      grid-template-columns: repeat(4, 1fr);
    }
  }

  .color-picker-multiple-container {
    position: absolute;
    top: 0;
    left: 0;
    background: white;

    box-shadow: 8px 2px 24px rgba(36, 36, 36, 0.03);
    border-radius: 6px;
    width: 100%;
    z-index: 10;
    .color-picker-multiple-header {
      background: $dark;
      grid-area: 1/1/2/-1;
      padding: 1rem;
      display: flex;
      align-items: center;
      justify-content: space-between;
      border-bottom: 1px solid $grey-light;
      p {
        color: white;
        text-transform: capitalize;
      }
    }

    .options-container {
      display: grid;
      grid-template-columns: repeat(2, 1fr);
      row-gap: 1rem;
      padding: 1rem 0.3rem 0.3rem 1rem;
      width: 100%;
    }

    ::v-deep .color-option {
      display: flex;
      align-items: center;

      ::v-deep ::v-deep .color-circle {
        margin-right: 1rem;
      }
    }
  }

  .picker-tooltip {
    &::after {
      content: " ";
      position: absolute;
      bottom: 100%; /* At the top of the picker-tooltip */
      margin-left: -5px;
      border-width: 5px;
      border-style: solid;
      border-color: transparent transparent $dark transparent;
      transition: all .2s;
    }
    &.first::after {
      left: 15%;
    }
    &.second::after {
      left: 50%;
    }
    &.third::after {
      left: 85%;
    }
  }
}
</style>
